module.exports = __webpack_public_path__ + "img/layout-text-window-reverse.e7194d32.svg";